import { configureStore } from "@reduxjs/toolkit";
import appReducer from './features/appSlice';
import communicationReducer from './features/communicationSlice';
import externalTransferForRepairReducer from "./features/inventoryTransfer/externalTransferForRepairslice";
import forgotPasswordReducer from './features/forgotPasswordSlice';
import inwardInventoryTransferReducer from "./features/inventoryTransfer/inwardInventoryTransferSlice";
import issueInventoryReducer from './features/issueInventorySlice';
import jobCardBattery from './features/batterySlice'
import jobCardReducer from './features/jobCardSlice';
import jobCardReportReducer from './features/reports/jobCardReportSlice'
import jobCardTaskReportReducer from './features/reports/jobCardTaskReportSlice'
import jobCardTyreReducer from './features/tyreSlice';
import loginReducer from './features/loginSlice';
import menuReducer from './features/menuSlice';
import outwardInventoryTransferReducer from './features/inventoryTransfer/outwardInventoryTransferSlice';
import purchaseReturnReducer from './features/purchaseReturnSlice'
import reportClosingStockSummaryReducer from './features/reports/closingStockSummarySlice';
import reportItemTransactionReducer from './features/reports/itemTransactionReportSlice';
import reportVehicleConsumptionReducer from './features/reports/vehicleConsumptionReportSlice';
import reportVehicleConsumptionQuickViewReducer from './features/reports/vehicleConsumptionQuickViewReportSlice';
import serviceTaskReducer from './features/serviceTaskSlice'
import serviceCalenderReducer from './features/serviceCalenderSlice'
import jobCardRepairAndService from './features/jcRepairAndserviceSlice'

export const store = configureStore({
    reducer: {
        app: appReducer,
        communication: communicationReducer,
        externalTransferForRepair:externalTransferForRepairReducer,
        forgotPassword: forgotPasswordReducer,
        inwardInventoryTransfer: inwardInventoryTransferReducer,
        issueInventory: issueInventoryReducer,
        menus: menuReducer,
        jobCardBattery: jobCardBattery,
        jobCard: jobCardReducer,
        jobCardTyre: jobCardTyreReducer,
        login: loginReducer,
        outwardInventoryTransfer:outwardInventoryTransferReducer,
        purchaseReturn: purchaseReturnReducer,
        reportClosingStockSummary: reportClosingStockSummaryReducer,
        reportJobCard: jobCardReportReducer,
        reportJobCardTask: jobCardTaskReportReducer,
        reportItemTransaction: reportItemTransactionReducer,
        reportVehicleConsumption: reportVehicleConsumptionReducer,
        reportVehicleConsumptionQuickView: reportVehicleConsumptionQuickViewReducer,
        serviceTask: serviceTaskReducer,
        serviceCalender: serviceCalenderReducer,
        jobCardRepairAndService:jobCardRepairAndService
    }
});
